import { buildAppUrl } from '../siteUrl';

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * Your Prii code is your profile link: a phone without Prii opens it in the browser (profile + App Store), a phone
 * with Prii opens the app (Universal Links cover /profile/*). It carries your name too, so a scan with no signal can
 * still say who you followed.
 */
export function priiCodeUrl(userId, name = '') {
  const n = String(name || '')
    .trim()
    .slice(0, 40);
  return buildAppUrl(`/profile/${userId}${n ? `?n=${encodeURIComponent(n)}` : ''}`);
}

/** A scanned string -> { userId, name } when it is a Prii profile link, else null. Any host: old and dev links count. */
export function parsePriiCode(value) {
  try {
    const url = new URL(String(value || '').trim());
    const m = url.pathname.match(/^\/profile\/([^/]+)\/?$/);
    if (!m || !UUID.test(m[1])) return null;
    return { userId: m[1].toLowerCase(), name: url.searchParams.get('n') || '' };
  } catch {
    return null;
  }
}
